// import { reactive } from 'vue';
import Footer from '../../components/Footer.vue';
import { onMounted, reactive, ref, toRefs } from 'vue';
import NavList from './components/NavList.vue';
import { useRouter } from 'vue-router';
// import axios from 'axios';
export default {
  components: {
    Footer,
    NavList
  },
  setup() {
    let data = reactive({
      images: ['/', 'https://unpkg.com/@vant/assets/apple-2.jpeg'],
      msgs: []
    });

    // const toList = () => {
    //   router.push('/noticelist')
    // }
    //请求
    // const getHomeData = () => {
    //   getApiHomeData().then((res)=>{
    //     // console.log(res);
    //     data.msgs = res.msgs
    //   })
    // axios.get("/home/getHomeData").then((res) => {
    //   console.log(res);
    //   const { code, homeData } = res.data
    //   if (code == 200) {
    //     data.msgs = homeData.msgs
    //   }
    // })
    // }
    // onMounted(() => {
    //   getHomeData();
    // })
    return {
      ...toRefs(data)
    };
  }
};